/**
 * 总代月度结算
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import { Spin, } from "antd";
import Lang from "@/components/Lang/Lang";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import dayjs from 'dayjs';
import {isEmpty} from "@utils/utils";
import "./Settlement.less";
class Settlement extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchFormOptionsOne:[
                {
                    name:'poCode',
                    cnTitle:'订单',
                    cnTitleId:'DingDan',
                    cnPlaceholder: '请输入PO单号',
                    cnPlaceholderId: 'QingShuRuPODanHao',
                },
                {
                    name:'buyerCode',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    cnPlaceholder:'编码/名称',
                    cnPlaceholderId:'BianMaMingCheng',
                },
                {
                    name:'fucName',
                    cnTitle:'分销商',
                    cnTitleId:'FenXiaoShang',
                    cnPlaceholder:'名称/账号',
                    cnPlaceholderId:'MingChengZhangHao',
                },
                {
                    name:'time',
                    cnTitle:'月份',
                    cnTitleId:'YueFen',
                    type:'Month',
                    canSearch:true,
                },
            ],
            columns:[
                {
                    dataIndex: 'buyerCode',
                    cnTitle: '客户',
                    cnTitleId: 'KeHu',
                },
                {
                    dataIndex: 'fucName',
                    cnTitle: '分销商',
                    cnTitleId: 'FenXiaoShang',
                    render: (fucName, record={}) => {
                        return(<div>
                            <p className={'color-black'}>{fucName}</p>
                            {record.userName&&<p className={'color-grey'}>{record.userName}</p>}
                        </div>)},
                },
                {
                    dataIndex: 'poNum',
                    cnTitle: '订单数',
                    cnTitleId: 'DingDanShu',
                },
                {
                    dataIndex: 'commissionRate',
                    cnTitle: '提成比例',
                    cnTitleId: 'TiChengBiLi',
                    render: (txt, record={}) => {
                        return(<div>
                            {txt&&<p className={'color-black'}>{Number(txt)*100}%</p>}
                        </div>)},
                },
                {
                    cnTitle: 'EXW总价',
                    cnTitleId: 'EXWZongJia',
                    dataIndex: 'exw',
                    type:'money',
                    showSymbol:'currencySymbol'
                },
                {
                    cnTitle: '提成金额',
                    cnTitleId: 'TiChengJinE',
                    dataIndex: 'commissionMoney',
                    type:'money',
                    showSymbol:'currencySymbol'
                },
            ],
            currencySymbol:'',
            totalCommission: 0,
            typesReturnSettlement:[],
            currRow:{},
        }
    }
    /**
     * 改变状态
     **/
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 导出
     */
    // handleExport = () => {
    //     let {userId} = Cookie.getJSON("fmg.extra") || {};
    //     let template =
    //         locale === "ru"
    //             ? "MgFenxiaoCommissionWithdrawItemReport_ru"
    //             : "MgFenxiaoCommissionWithdrawItemReport_zh";
    //     let href =
    //         config.servers[config.environment].exportApi +
    //         `/data/bpms/jreport/mg/fexiaoCommission/withdrawItem/print?template=${template}&userId=${userId}`;
    //     //地址拼接，如果没有数据也要拼接
    //     href += `&langCode=${locale}`; ;
    //     href += "&isCheck=0";
    //     window.open(href);
    // };
    specialHandleTime(map){
        if(map.time){
            const star = dayjs(map.time).startOf('month');
            const end = dayjs(map.time).endOf('month');
            map['happenTimeStart'] = star.valueOf();
            map['happenTimeEnd'] = end.valueOf();
            delete map['time'];
        }
        return map
    }

    fetchCallBack(res){
        const {success,valid,model,extra} = res;
        if (success && valid) {
            this.setState({
                currencySymbol:extra.currencySymbol,
                totalCommission:model||0
            })
        }else this.setState({
            totalCommission: 0
        })
    }
    componentDidMount() {}
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { loading,searchFormOptionsOne, columns, totalCommission,currencySymbol } = this.state;
        const currPageName = Lang({id: "ZongDaiYueDuJiXu",default: "总代月度结算"});
        // const setRight =(<div className={'textRight'}>
        //     <Button onClick={() => {this.handleExport()}} icon={<span className="iconfont icon-export font_14 mr_10"></span>}>
        //         <span className="font_12">{Lang({id: "DaoChuShuJu"})}</span>
        //     </Button>
        // </div>);
        return (<Spin tip='loading' spinning={loading}>
                <div className="distributor-settlement-warp">
                    <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                    <div className={"top-title mb_16"}>{currPageName}</div>
                    <AutoFetchTable columns={columns}
                                    rowKey={'buyerId'}
                                    onRef={this.onRefTabOne}
                                    topSearchLeftCont={<div className={'total'}>{Lang({id: "TiChengZongJi",default: "提成总计"})}：{currencySymbol}<span className={'margin-left-4'}>{totalCommission}</span></div>}
                                    // topSearchRightCont={setRight}
                                    specialHandle={this.specialHandleTime}
                                    fetchCallBack={(res)=>this.fetchCallBack(res)}
                                    searchFormOptions={searchFormOptionsOne}
                                    precondition={{ //前置条件
                                        time:dayjs()
                                    }}
                                    fetchApi={'/service/mg/distributor/commission-by-month'}>

                    </AutoFetchTable>
                </div>
            </Spin>

        )
    }
}

export default Settlement;
